import store from '@/store'

const getters = {
  ui_modal_bible_auth: state => state.ui.modal_bible_auth.opened,
  token: state => state.auth.token,
  name: state => state.auth.name,
  level: state => state.auth.level,
  id: state => state.auth.id,
  verse(state) {
    return params => {
      if (params.code) {
        for (let i = 0; i < store.state.data.chapter.verses.length; i++) {
          if (params.code === store.state.data.chapter.verses[i].code) {
            return store.state.data.chapter.verses[i]
          }
        }
      }
      return null
    }
  },
  bible_search_options(state) {
    const bibleOld = [ 'old' ]
    const bibleNew = [ 'new' ]
    const bibleApo = [ 'apo' ]
    let options = [
      {
        value: bibleOld.concat(bibleNew).join(','),
        text: '全体',
      },
      {
        value: bibleOld.join(','),
        text: '旧約',
      },
      {
        value: bibleNew.join(','),
        text: '新約',
      },
    ]
    if (state.setting.apocrypha.value) {
      options[0].value = bibleOld.concat(bibleNew, bibleApo).join(',')
      options.push({
        value: bibleApo.join(','),
        text: '続編',
      })
    }
    return options
  },
}
export default getters

